export default __webpack_public_path__ + "static/media/partners.482426a3.jpg";